import styled from 'styled-components';

const TopBarStyle = styled.div`
	--breadCrumbArrowMargin: 0 var(--sp2x);

	--selectMaxWidth: var(--sp40x);

	display: flex;
	justify-content: space-between;

	.breadcrumbs {
		display: flex;
		align-items: center;

		.breadcrumb-item-wrap {
			display: flex;
			align-items: center;

			.breadcrumb-arrow {
				font-size: var(--sp1-5x);
				transform: rotate(-90deg);
				margin: var(--breadCrumbArrowMargin);
			}

			&:last-child {
				cursor: default;
				pointer-events: none;
			}
		}
	}

	.sort-by {
		width: var(--selectMaxWidth);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--selectMaxWidth: var(--sp34x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--selectMaxWidth: var(--sp33x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--selectMaxWidth: var(--sp30x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		/* display: none; */
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		/* display: none; */

		.breadcrumb-item-wrap {
			&:last-child {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
			}
		}
	}
`;

export default TopBarStyle;
